import { useId } from "react";
import { useTranslation } from "react-i18next";
import { useBrand } from "../context/BrandContext";
import "./SportClubsOneHealthIntro.css";

const DIMS = [
  { id: "physical", className: "onehealth-intro__dim--physical" },
  { id: "mental", className: "onehealth-intro__dim--mental" },
  { id: "social", className: "onehealth-intro__dim--social" },
];

/**
 * Staff signup primer: ONE Health at the club, aligned with
 * Sports Club for Health (SCforH) recommendations.
 */
export default function SportClubsOneHealthIntro({
  clubName = "",
  variant = "compact",
  tone = "auto",
  lng,
} = {}) {
  const { t, i18n } = useTranslation();
  const { themeMode } = useBrand();
  const headingId = useId();
  const translate = lng ? i18n.getFixedT(lng) : t;
  const club = String(clubName || "").trim();
  const resolvedTone =
    tone === "auto" || tone == null
      ? themeMode === "dark"
        ? "dark"
        : "light"
      : tone;

  return (
    <section
      className={`onehealth-intro onehealth-intro--${variant} onehealth-intro--${resolvedTone}`}
      aria-labelledby={headingId}
    >
      <p className="onehealth-intro__eyebrow">{translate("oneHealthIntroEyebrow")}</p>
      <h3 id={headingId} className="onehealth-intro__title">
        {translate("oneHealthIntroTitle")}
      </h3>
      <p className="onehealth-intro__body">
        {club
          ? translate("oneHealthIntroBody", { club })
          : translate("oneHealthIntroBodyNoClub")}
      </p>
      <ul className="onehealth-intro__dims">
        {DIMS.map((dim) => (
          <li key={dim.id} className={`onehealth-intro__dim ${dim.className}`}>
            <span className="onehealth-intro__dim-mark" aria-hidden="true" />
            <span>{translate(`scforhIntroDim_${dim.id}`)}</span>
          </li>
        ))}
      </ul>
      <p className="onehealth-intro__smarttt">{translate("oneHealthIntroSmarttt")}</p>
    </section>
  );
}
